
import { Button, Typography, useTheme } from '@hmsexp/component-library';
import React, { useEffect } from 'react';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { View } from 'react-native';
import { connect } from 'react-redux';
import get from 'lodash/get';
import withRouterHOC from '../../../../common/components/WithRouteHOC';
import NotFoundIcon from '../../icon/NotFound';
import { openParentWindow } from '../../utils/openParentWindow';
import fetchTranslationsFromClient from '../../../../common/actions/fetchTranslationsFromClient';
import getSelectedLocale from '../../../../common/selectors/getSelectedLocale';
import styles from './styles';

const TRANSLATIONS_FEATURE_NAME = 'clientMessages';

const NotFound = props => {
  const { customHistory, activeHotelId, language } = props;

  useEffect(() => {
    props.fetchTranslationsFromClient({
      language: props.language
    });
  }, [language]);

  const theme = useTheme();
  function onGoHomeClick() {
    customHistory.push({
      screen: 'homeView',
      params: {
        ':hotel_id': activeHotelId
      }
    });
  }

  function goBackToOyoOs() {
    openParentWindow('oyo os');
  }

  return (
    <IntlProvider locale={props.language} messages={props.translations}>
      <View style={styles.parentContainer}>
        <View style={[styles.container, { backgroundColor: theme.palette.primaryBackgroundLow }]}>
          <NotFoundIcon />

          <View style={{ marginBottom: 16 }}>
            <Typography fontWeightType={'medium'} variant={'h5'}>
              <FormattedMessage id='notFoundText' />
            </Typography>
          </View>
          <View style={{ marginBottom: 16 }}>
            <Typography fontWeightType={'medium'} variant={'body1'}>
            <FormattedMessage id='notFoundDescription' />
            </Typography>
          </View>
          <View style={styles.bottomButton}>
            <Button
              title={<FormattedMessage id='goBackFromNotFoundPage' />}
              onClick={onGoHomeClick}
              style={{
                buttonContainer: {
                  width: 200,
                  height: 20
                }
              }}
            />

            <Button
              title={<FormattedMessage id='goBackToOyoOs' />}
              onClick={goBackToOyoOs}
              style={{
                buttonContainer: {
                  width: 200,
                  height: 20,
                  marginLeft: 5
                }
              }}
            />
          </View>
        </View>
      </View>
    </IntlProvider>
  );
};
const mapStateToProps = state => {
  const translations = get(state.translationsReducer, 'translations.data', {});
  return {
    activeHotelId: state.dashboard.active_hotel_id,
    language: getSelectedLocale(state),
    translations: translations[TRANSLATIONS_FEATURE_NAME],
  };
};

export default withRouterHOC(connect(mapStateToProps, { fetchTranslationsFromClient })(NotFound));
